import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.lastSendNotificationTime.loading;
export const selectErrorMessage = (state: RootState) =>
  state.lastSendNotificationTime.error;
export const lastSendNotificationTimeResponse = (state: RootState) =>
  state.lastSendNotificationTime.lastSendNotificationTimeResponse;
